"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GleamWrapperMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Gleam = require("../../components/Gleam/Gleam.styles");
var _spaceMixin = require("../spaceMixin");
/** @class GleamWrapperMixin */
/** @method */
var GleamWrapperMixin = function GleamWrapperMixin(props) {
  return (0, _styledToken.default)({
    positionTop: 'GleamWrapper.position.top',
    positionRight: 'GleamWrapper.position.right'
  }, function (_ref) {
    var positionTop = _ref.positionTop,
      positionRight = _ref.positionRight;
    return (0, _styledComponents.css)(["display:inline-block;position:relative;", "{position:absolute;top:calc(-1 * ", ");right:calc(-1 * ", ");}"], _Gleam.StyledGleam, positionTop ? positionTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), positionRight ? positionRight + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.GleamWrapperMixin = GleamWrapperMixin;